import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { CLINIC, ASSETS, buildWhatsAppUrl } from "@/constants/site";
import { TESTIDS } from "@/constants/testIds";

const links = [
  { to: "/",             label: "Início",       tid: TESTIDS.navHome },
  { to: "/servicos",     label: "Serviços",     tid: TESTIDS.navServices },
  { to: "/quem-somos",   label: "Quem Somos",   tid: TESTIDS.navAbout },
  { to: "/blog",         label: "Blog",         tid: TESTIDS.navBlog },
  { to: "/contato",      label: "Fale Conosco", tid: TESTIDS.navContact },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `text-sm font-medium transition-colors duration-200 ${
      isActive ? "text-brand-600" : "text-slate-700 hover:text-brand-600"
    }`;

  return (
    <header
      data-testid={TESTIDS.header}
      className="glass-header sticky top-0 z-40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <Link to="/" data-testid={TESTIDS.logo} className="flex items-center gap-2 group">
            <img
              src={ASSETS.logo}
              alt="Visiovet Diagnóstico Veterinário"
              className="h-10 sm:h-11 w-auto transition-transform duration-200 group-hover:scale-105"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={l.tid} className={linkClass} end={l.to === "/"}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={`tel:+55${CLINIC.phoneMobile.replace(/\D/g,'')}`}
              className="flex items-center gap-2 text-sm text-slate-700 hover:text-brand-600"
            >
              <Phone className="w-4 h-4" /> {CLINIC.phoneMobile}
            </a>
            <a
              href={buildWhatsAppUrl("Olá Visiovet! Vim do site.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={TESTIDS.ctaWhatsAppHeader}
              className="rounded-full bg-brand-500 text-white text-sm font-semibold px-5 py-2.5 shadow-lg shadow-brand-500/30 hover:bg-brand-600 hover:-translate-y-0.5 transition-[background-color,transform] duration-200"
            >
              Agendar exame
            </a>
          </div>

          <button
            data-testid={TESTIDS.mobileMenuToggle}
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-md text-slate-700 hover:bg-slate-100"
            aria-label="Abrir menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 border-t border-slate-200">
            <nav className="flex flex-col gap-3 pt-4">
              {links.map((l) => (
                <NavLink key={l.to} to={l.to} data-testid={`m-${l.tid}`} onClick={() => setOpen(false)} className={linkClass} end={l.to === "/"}>
                  {l.label}
                </NavLink>
              ))}
              <a
                href={buildWhatsAppUrl("Olá Visiovet! Vim do site.")}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-brand-500 text-white text-center text-sm font-semibold px-5 py-3 mt-2"
              >
                Agendar exame no WhatsApp
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
